"use strict";

CompanyPublicationVersionsCtrl.$inject = ['$scope', '$stateParams', 'publication', 'files'];
function CompanyPublicationVersionsCtrl($scope, $stateParams, publication, files) {
  $scope.publication = publication;
  $scope.files       = files.slice(0, 20);
  $scope.currentPage = $stateParams.page|0;
  $scope.hasNext     = files.length > 20;
}

CompanyPublicationVersionsCtrl.resolve = {
  files: ['$stateParams', 'CompanyPublicationFileService', 'company', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 21, offset: ($stateParams.page|0) * 20 + 1}).$promise;
  }]
};

module.exports = CompanyPublicationVersionsCtrl;

angular.module("dokiv")
  .controller("CompanyPublicationVersionsCtrl", CompanyPublicationVersionsCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationVersionsCtrl.js
// module id = 382
// module chunks = 0